import { useRef } from "react";
import { Icon } from "@common/index";
import { useDialogFocusTrap } from "@/hooks/useDialogFocusTrap";

interface CoaModalProps {
    onClose: () => void;
}

// The Certificate of Authenticity (COA, DecisionLog I3) note for a product
// that has no COA attached: it shows only the "request from sales rep" copy.
// A product with a COA offers its download instead (ProductCoaDownload).
export const CoaModal = ({ onClose }: CoaModalProps) => {
    const panelRef = useRef<HTMLDivElement>(null);
    // The backdrop here is its own full-bleed Close button (below), so the
    // hook's backdrop handlers are not used.
    const { panelProps } = useDialogFocusTrap({
        panelRef,
        isProcessing: false,
        onRequestClose: onClose,
        focusPanelOnOpen: true,
    });

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <button
                type="button"
                aria-label="Close"
                className="absolute inset-0 bg-black/40"
                onClick={onClose}
            />
            <div
                ref={panelRef}
                role="dialog"
                aria-modal="true"
                aria-label="Certificate of Authenticity"
                {...panelProps}
                className="relative bg-base-100 rounded-lg w-full max-w-sm shadow-xl focus:outline-none"
            >
                <div className="flex items-center justify-between p-4 border-b border-base-300">
                    <h2 className="font-bold text-lg text-neutral">
                        Certificate of Authenticity
                    </h2>
                    <button
                        type="button"
                        aria-label="Close"
                        onClick={onClose}
                        className="btn btn-ghost btn-sm btn-square text-neutral"
                    >
                        <Icon name="close" className="text-xl" />
                    </button>
                </div>
                <div className="p-4 text-sm text-neutral">
                    COA available on request — contact your sales rep.
                </div>
            </div>
        </div>
    );
};
